import React from 'react';
import { LpLink } from '../LpLink';
import {
    Header as DesktopHeader,
    HeaderItem as DesktopHeaderHeaderItem,
    HeaderSubItem as DesktopHeaderSubItem,
} from './HeaderDesktop';
import {
    Header as MobileHeader,
    HeaderItem as MobileHeaderHeaderItem,
    HeaderSubItem as MobileHeaderSubItem,
} from './HeaderMobile';
import { HeaderProps as RawHeaderProps, HeaderItem } from './types';

export type HeaderProps = Omit<RawHeaderProps, 'children'> & {
    items: HeaderItem[];
};

const toMobileChildren = (item: HeaderItem, index: number) => {
    return (
        <MobileHeaderHeaderItem key={index} href={item.href} text={item.text}>
            {item.subItems?.map((subItem, idx) => (
                <MobileHeaderSubItem
                    href={subItem.href}
                    icon={subItem.icon}
                    key={idx}
                    title={subItem.title}
                />
            ))}
        </MobileHeaderHeaderItem>
    );
};

const toDesktopChildren = ({
    item,
    index,
    open,
    setOpen,
}: {
    item: HeaderItem;
    index: number;
    open: boolean;
    setOpen: (id: number) => void;
}) => {
    return (
        <DesktopHeaderHeaderItem
            open={open}
            setOpen={() => setOpen(index)}
            key={index}
            href={item.href}
            text={item.text}>
            {item.subItems?.map((subItem, idx) => (
                <DesktopHeaderSubItem
                    href={subItem.href}
                    icon={subItem.icon}
                    key={idx}
                    title={subItem.title}>
                    {subItem.description}
                </DesktopHeaderSubItem>
            ))}
        </DesktopHeaderHeaderItem>
    );
};

export const Header = ({
    loginButton,
    signupButton,
    items,
    logo,
    showSignupButton,
    hideMenu,
    hideButtons,
    disableLogoLink,
}: HeaderProps): JSX.Element => {
    const spawn = (): boolean[] => Array(items.length).fill(false);
    const [openVector, setOpenVector] = React.useState<boolean[]>(spawn());
    const setOpen = (id: number) => {
        const vector = spawn();
        vector[id] = !openVector[id];
        setOpenVector(vector);
    };
    const linkLogo = (
        <LpLink
            to={disableLogoLink ? undefined : '/'}
            style={{ display: 'flex', marginBottom: '3px' }}>
            {logo}
        </LpLink>
    );
    return (
        <>
            <DesktopHeader
                loginButton={loginButton}
                signupButton={signupButton}
                hideMenu={hideMenu}
                hideButtons={hideButtons}
                logo={linkLogo}>
                {items.map((item, index) =>
                    toDesktopChildren({
                        item,
                        index,
                        open: openVector[index],
                        setOpen,
                    })
                )}
            </DesktopHeader>
            <MobileHeader
                hideMenu={hideMenu}
                hideButtons={hideButtons}
                loginButton={loginButton}
                signupButton={signupButton}
                logo={linkLogo}
                showSignupButton={showSignupButton}>
                {items.map((item, idx) => toMobileChildren(item, idx))}
            </MobileHeader>
        </>
    );
};
